import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactDOM from 'react-dom';

import ReactPortal from '@stubhub/react-portal';

import './index.scss';

const STATUS_TYPE = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};
export default class Message extends Component {
  static propTypes = {
    duration: PropTypes.number,
    onClose: PropTypes.func,
    type: PropTypes.oneOf(Object.values(STATUS_TYPE)),
    text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    manualClickable: PropTypes.bool,
    autoClose: PropTypes.bool,
  };

  static defaultProps = {
    duration: 3,
  };

  componentDidMount() {
    const {type, manualClickable, autoClose} = this.props;

    if ((type !== STATUS_TYPE.ERROR && !manualClickable) || autoClose) {
      this.startCloseTimer();
    }
  }

  startCloseTimer = () => {
    this.closeTimer = setTimeout(() => {
      this.close();
    }, this.props.duration * 1000);
  };

  clearCloseTimer = () => {
    clearTimeout(this.closeTimer);
  };

  close = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.clearCloseTimer();
    this.props.onClose && this.props.onClose();
  };

  render() {
    const {type, text} = this.props;

    return (
      <ReactPortal>
        <div className="page__notification__container">
          <div className="page__notice__wrapper">
            <div className={classNames('page__status', type)}>
              <div className={classNames('status__icon', type)} />
              <div className="status__content">{text}</div>
              <div className="page__close--btn" onClick={this.close}></div>
            </div>
          </div>
        </div>
      </ReactPortal>
    );
  }
}

const className = 'Bullet__Notification';

const renderMessage = (message, type, autoClose) => {
  const div = document.createElement('div');
  div.className = className;
  document.body.appendChild(div);
  const onClose = () => {
    ReactDOM.unmountComponentAtNode(div);
    if (div.parentNode) {
      div.parentNode.removeChild(div);
    }
  };
  ReactDOM.render(<Message autoClose={autoClose} type={type} text={message} onClose={onClose} />, div);
};

const handleError = (message, autoClose) => {
  renderMessage(message, STATUS_TYPE.ERROR, autoClose);
};

const handleSuccess = (message, autoClose) => {
  renderMessage(message, STATUS_TYPE.SUCCESS, autoClose);
};

const open = {
  error: handleError,
  success: handleSuccess,
};

export {open};
